import { Injectable } from '@angular/core';
import { BaseTableService } from './base-table.service';
import { PlcAlarmCode } from 'src/app/model/station-logs/plc-alarm-code';

@Injectable({
  providedIn: 'root',
})
export class PlcAlarmCodeTableService extends BaseTableService<PlcAlarmCode> {
  constructor() {
    super();
  }
}
